export default __webpack_public_path__ + "static/media/locker.29fff2a7.svg";